import { h } from '@stencil/core';
export class SubcategoryList {
  constructor() {
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("section", { class: "subcategory-list" }, h("slot", { name: "pes-subcategory-block" })));
  }
  static get is() { return "pes-subcategory-list"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["subcategory-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["subcategory-list.css"]
    };
  }
  static get elementRef() { return "el"; }
}
